import { render, staticRenderFns } from "./providerInfoReadonly.vue?vue&type=template&id=64fccfaa&scoped=true&"
import script from "./providerInfoReadonly.vue?vue&type=script&lang=babel&"
export * from "./providerInfoReadonly.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fccfaa",
  null
  
)

export default component.exports